import { api } from "@Aspecto/backend/convex/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { AppPageContent } from "@/components/layout/app-page";

export const Route = createFileRoute("/_authenticated/app/events/create")({
  component: EventsCreateRedirect,
});

function EventsCreateRedirect() {
  const { data: groups } = useQuery(convexQuery(api.groups.getCompanyGroups, {}));

  if (groups === undefined) {
    return (
      <AppPageContent>
        <p className="py-6 text-sm text-muted-foreground">Loading…</p>
      </AppPageContent>
    );
  }

  const global = groups.find((g) => g.isGlobal);
  const fallback = groups[0];
  const groupId = global?._id ?? fallback?._id;

  if (!groupId) {
    return <Navigate to="/app/events" replace />;
  }

  return <Navigate to="/app/groups/$groupId/events" params={{ groupId }} replace />;
}
